module.exports = __webpack_public_path__ + "img/logo-navbar.df825fd6.svg";